import clsx from 'clsx';

import { POST, STORY } from '@/lib/posts/postTypes';

type PlaceholderProps = {
    type?: typeof POST | typeof STORY;
};
const Placeholder = ({ type = POST }: PlaceholderProps) => {
    return (
        <div
            className={clsx(
                'w-full animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite',
                { square: type === POST, storyImg: type === STORY }
            )}
        />
    );
};

export default Placeholder;
